<template>

    <b-navbar toggleable="lg" type="dark" variant="info" class="navbar c-navbar" sticky>
        <b-navbar-brand to="/">

            <img class="c-navbar__img" :src="'/img/logo.png'" alt="">

        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>

            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item to="/attendance-sheet">Docházka
                </b-nav-item>
                <b-nav-item to="/garage-material">Materiál Garáž
                </b-nav-item>
                <b-nav-item to="/material-climbing-wall">Materiál Stěna
                </b-nav-item>
                <b-nav-item to="/video">Cvičení
                </b-nav-item>
                <b-nav-item-dropdown v-if="isAdmin" text="Admin">
                    <b-dropdown-item to="/garage-material/edit">Materiál Garáž</b-dropdown-item>
                    <b-dropdown-item to="/material-climbing-wall/edit">Materiál Stěna</b-dropdown-item>
                    <b-dropdown-item to="/students">Děti</b-dropdown-item>
                    <b-dropdown-item to="/courses">Akce</b-dropdown-item>
                    <b-dropdown-item :href="path + 'garage-material/export-to-csv.php'">Export revizí
                    </b-dropdown-item>
                    <b-dropdown-item to="/texts">Texty</b-dropdown-item>
                    <b-dropdown-item to="/users">Uživatelé</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item >
                    <span>
                        <b-icon class="clickable ml-1"
                                icon="person-fill" variant=""
                        ></b-icon>
                        {{user.name}}
                    </span>
                    <b-icon @click="logout"
                            title="Odhlásit"
                            class="clickable ml-1"
                            icon="box-arrow-right" variant=""
                            ></b-icon>
                </b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>

</template>

<script>
    export default {
        name: 'navbar',
        data() {
            return {
                path: process.env.VUE_APP_SERVER
            }
        },
        computed : {
            isLoggedIn : function(){ return this.$store.getters.isLoggedIn},
            user : function () { return this.$store.getters.user },
            isAdmin : function () { return this.$store.getters.isAdmin }
        },
        methods: {
            logout: function () {
                this.$store.dispatch('logout')
                    .then(() => {
                        this.$router.push('/login')
                    })
            }
        },
    }
</script>

<style  lang="scss">
    .c-navbar {
        //box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.35);
        font-family: 'Bebas Neue', cursive;
        font-size: 1.5rem;

        &__img {
            max-height: 30px;
        }
        .nav-link {
            color: white!important;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
                display: flex;

            }
        }
        .navbar-nav .dropdown-menu .dropdown-item {
            color: #17a2b8;
        }

    }

</style>
